import { MoveGenerator } from '../../jscaip/AI/AI';
import { Ordinal } from '../../jscaip/Ordinal';
import { PlayerOrNone } from '../../jscaip/Player';
import { EpaminondasMove } from './EpaminondasMove';
import { EpaminondasRules } from './EpaminondasRules';
export class EpaminondasMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const player = node.gameState.getCurrentPlayer();
        const opponent = node.gameState.getCurrentOpponent();
        const empty = PlayerOrNone.NONE;
        let moves = [];
        const state = node.gameState;
        for (const coordAndContent of state.getCoordsAndContents()) {
            const firstCoord = coordAndContent.coord;
            if (coordAndContent.content === player) {
                for (const direction of Ordinal.ORDINALS) {
                    let phalanxSize = 1;
                    let nextCoord = firstCoord.getNext(direction, 1);
                    while (state.hasPieceAt(nextCoord, player)) {
                        phalanxSize += 1;
                        nextCoord = nextCoord.getNext(direction, 1);
                    }
                    let stepSize = 1;
                    while (stepSize <= phalanxSize && state.hasPieceAt(nextCoord, empty)) {
                        const move = new EpaminondasMove(firstCoord.x, firstCoord.y, phalanxSize, stepSize, direction);
                        moves = this.addMove(moves, move, state);
                        stepSize++;
                        nextCoord = nextCoord.getNext(direction, 1);
                    }
                    if (stepSize <= phalanxSize && state.hasPieceAt(nextCoord, opponent)) {
                        const move = new EpaminondasMove(firstCoord.x, firstCoord.y, phalanxSize, stepSize, direction);
                        moves = this.addMove(moves, move, state);
                    }
                }
            }
        }
        return moves;
    }
    addMove(moves, move, state) {
        const legality = EpaminondasRules.isLegal(move, state);
        if (legality.isSuccess()) {
            moves.push(move);
        }
        return moves;
    }
}
